import React, { Fragment } from "react";
import { Link } from "react-router-dom";

import GreenLogo from "../Innovators/GreenLogo";
import IMEAltLogo from "./IMEAltLogo";

const MinimumNav = ({ user }) => {
  return (
    <Fragment>
      <nav className="login-nav background-dark-black border-bottom grey">
        <div className="action-items-index">
          <Link to="/">
            <div
              className={`action-button-index ${
                user && user.role === "innovator"
                  ? "green"
                  : user && user.role === "mentor"
                  ? "red"
                  : user && user.role === "employer"
                  ? "blue"
                  : "green"
              }`}
            >
              <i
                className={`fas fa-angle-left action-icon-index-alt fa-lg ${
                  user && user.role === "innovator"
                    ? "green"
                    : user && user.role === "mentor"
                    ? "red"
                    : user && user.role === "employer"
                    ? "blue"
                    : "green"
                }`}
              ></i>
            </div>
          </Link>
          <p
            className={`action-text-index ${
              user && user.role === "innovator"
                ? "green"
                : user && user.role === "mentor"
                ? "red"
                : user && user.role === "employer"
                ? "blue"
                : "green"
            }`}
          >
            Back
          </p>
        </div>
        <Link to="/">
          <div className="center-nav">
            <div className="index-logo-alt">
              <GreenLogo />
            </div>
            <i className="fas fa-trademark fa-sm green mt-10"></i>
            <div className="index-logo">
              <IMEAltLogo />
            </div>
          </div>
        </Link>
      </nav>
    </Fragment>
  );
};

export default MinimumNav;
